import React, { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getAnalyzeChannelsChannelShareWeeklyModel } from 'app/store/reducers/analyzeChannels.reducer';
import { IAnalyzeChannelsChannelShareParams } from 'entities/AnalyzeChannels/AnalyzeChannels.models';
import { ChannelShareWeeklyChart } from 'entities/AnalyzeChannels/components/ChannelShareWeeklyChart';

interface IComponentProps {
  params?: IAnalyzeChannelsChannelShareParams;
}

export const AnalyzeChannelsChannelShareWeeklyBlock: FC<IComponentProps> = ({ params }) => {
  const dispatch = useAppDispatch();

  const { analyzeChannelsChannelShareWeeklyModel, analyzeChannelsChannelShareWeeklyModelLoading } = useAppSelector(
    (state) => state.analyzeChannels
  );

  useEffect(() => {
    dispatch(getAnalyzeChannelsChannelShareWeeklyModel(params));
  }, [params?.storeCode, params?.week]);

  return (
    <div className="ac-block">
      <div className="ac-block__header">
        <span className="ff-medium fs-xs">Last 52 weeks</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div className="ac-block__body">
        {analyzeChannelsChannelShareWeeklyModelLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <ChannelShareWeeklyChart data={analyzeChannelsChannelShareWeeklyModel} />
        )}
      </div>
    </div>
  );
};
